import React from 'react';
import { Download, Trash2 } from 'lucide-react';

interface FileActionsProps {
  selectedFiles: string[];
  onDownload: (files: string[]) => void;
  onDelete: (files: string[]) => void;
}

export default function FileActions({ selectedFiles, onDownload, onDelete }: FileActionsProps) {
  if (selectedFiles.length === 0) return null;

  return (
    <div className="flex items-center gap-2 mb-4">
      <span className="text-sm text-gray-600">
        {selectedFiles.length} {selectedFiles.length === 1 ? 'fișier selectat' : 'fișiere selectate'}
      </span>
      <div className="flex gap-2">
        <button
          onClick={() => onDownload(selectedFiles)}
          className="flex items-center gap-2 px-3 py-1.5 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition"
        >
          <Download className="w-4 h-4" />
          Descarcă
        </button>
        <button
          onClick={() => onDelete(selectedFiles)}
          className="flex items-center gap-2 px-3 py-1.5 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition"
        >
          <Trash2 className="w-4 h-4" />
          Șterge
        </button>
      </div>
    </div>
  );
}